import {useContext} from 'react'
import {AuthContext} from '../context'
import {Navigate, useLocation} from 'react-router-dom'
import {getStoredAuthSession} from '../utils/authSession'

export const PrivateRoute = ({children}) => {
	const {authState} = useContext(AuthContext)
	const location = useLocation()
	const session = getStoredAuthSession()
	const hasValidSession = Boolean(session?.token || (authState?.logged && authState?.token))

	return hasValidSession ? children : <Navigate to='/LoginNew' replace state={{from: location}} />
}
